import { useSquarePayments } from './square-payments.hooks';
import { SquareProvider } from './square.context';

const SquarePayments = ({ children }) => {
  const value = useSquarePayments();
  return <SquareProvider value={value}>{children}</SquareProvider>;
};

export default SquarePayments;
